import { getNestedProperty } from '@opallabs/lambda'
import { State, StateKeys } from '../../../../types'

type GetIds = (state: State) => string[] | undefined

export const getTodoPhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.todo',
    StateKeys.phase_item
  )

export const getTodoAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.todo',
    StateKeys.assignment
  )

export const getOverduePhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.overdue',
    StateKeys.phase_item
  )

export const getOverdueAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.overdue',
    StateKeys.assignment
  )

export const getCompletedPhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.completed',
    StateKeys.phase_item
  )

export const getCompletedAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.completed',
    StateKeys.assignment
  )

export const getUpcomingPhaseItemsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.upcoming',
    StateKeys.phase_item
  )

export const getUpcomingAssignmentsIds: GetIds = (state) =>
  getNestedProperty<string[]>(
    state,
    StateKeys.entityDataByView,
    StateKeys.personalPanel,
    'tasks.upcoming',
    StateKeys.assignment
  )
